import { render } from "./CadastrarFuncionario.vue?vue&type=template&id=2791dd3f&scoped=true"
import script from "./CadastrarFuncionario.vue?vue&type=script&lang=js"
export * from "./CadastrarFuncionario.vue?vue&type=script&lang=js"

import "./CadastrarFuncionario.vue?vue&type=style&index=0&id=2791dd3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2791dd3f"]])

export default __exports__